import React, { useState } from 'react';
import cx from 'classnames';
import classes from './SectionNav.module.scss';

export interface SectionDef {
  id: string;
  label: string;
}

export interface SectionNavProps {
  sections: SectionDef[];
  active: string;
  onGo: (id: string) => void;
}

export const SectionNav: React.FC<SectionNavProps> = ({ sections, active, onGo }) => {
  const [hoveredId, setHoveredId] = useState<string | null>(null);

  return (
    <div className={classes.navRail}>
      <div className={classes.rail}>
        {sections.length > 1 && <div className={classes.track} />}
        {sections.map((section) => {
          const isActive = section.id === active;
          return (
            <div
              key={section.id}
              className={classes.dotRow}
              onMouseEnter={() => setHoveredId(section.id)}
              onMouseLeave={() => setHoveredId(null)}
            >
              <button
                type="button"
                aria-label={section.label}
                className={cx(classes.dot, { [classes.dotActive]: isActive })}
                onClick={() => onGo(section.id)}
              >
                {isActive && <span className={classes.dotInner} />}
              </button>
              {hoveredId === section.id && <div className={classes.tooltip}>{section.label}</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
};

SectionNav.displayName = 'SectionNav';
